<template>
  <div>
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>#</th>
          <th>Info</th>
          <th>Amount</th>
          <th>Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(detail, key) in arr_detail">
          <td>{{ key + 1 }}</td>
          <td>{{ detail.name }}</td>
          <td class="text-right">{{ detail.amount.toLocaleString('id-ID') }}</td>
          <td class="text-right">Rp. {{ detail.price.toLocaleString('id-ID') }}</td>
          <td class="text-right">Rp. {{ (detail.amount * detail.price).toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-center">Sub-Total</td>
          <td class="text-right">Rp. {{ invoice.sub_total.toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-center">Admin Fee</td>
          <td class="text-right">Rp. {{ invoice.admin_fee.toLocaleString('id-ID') }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-center">Total</td>
          <td class="text-right">Rp. {{ invoice.total_price.toLocaleString('id-ID') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default{
  props: ['invoice', 'arr_detail',],
}
</script>
